import { ModelCard } from 'components/driving/model-card/model-card'
export default ModelCard
